import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { useMenuOptionGroup } from '../use-menu.esm.js';
import MenuGroup from '../MenuGroup/index.esm.js';

var MenuOptionGroup = function MenuOptionGroup(props) {
  var title = props.title;

  var _useMenuOptionGroup = useMenuOptionGroup(props),
      children = _useMenuOptionGroup.children,
      rest = _objectWithoutPropertiesLoose(_useMenuOptionGroup, ["children"]);

  return React__default.createElement(MenuGroup, _extends({
    title: title
  }, rest), children);
};

export default MenuOptionGroup;
//# sourceMappingURL=index.esm.js.map
